import { Location } from "react-router-dom";
import { UserInfoContextType } from "../packages/context/userinfo/UserInfoContext";
import { getMenuRoles } from "../packages/accessControl/routeAccess";
import { hasVisitedConsoleSessionStorage } from "../packages/utils/utils";

export const getSideBarCollapsedClass = (isSideBarCollapsed: boolean, classes: string) => {
  return isSideBarCollapsed ? classes : "";
};

export const getNavbarClass = (isSideBarCollapsed: boolean) =>
  isSideBarCollapsed
    ? `sidebar-nav overflow-y-auto pb-5`
    : `sidebar-nav overflow-y-auto px-6 pb-10`;

export const getHeaderClass = (isSideBarCollapsed: boolean) =>
  isSideBarCollapsed ? `header pb-4` : `header pb-4 px-6`;

const isAuthorisedButNotVisitedConsole = (userInfo: UserInfoContextType | null) => {
  const activeTenant = userInfo?.data?.activeTenant;
  const fpConsoleEnabledRoles = getMenuRoles("/fp-console", activeTenant);
  return (
    hasVisitedConsoleSessionStorage.get() !== "true" &&
    userInfo?.data.userInfo?.roles?.some((role) => fpConsoleEnabledRoles.includes(role))
  );
};

export const shouldRedirectToConsole = (
  location: Location<any>,
  userInfo: UserInfoContextType | null
) => {
  return location.pathname === "/" && isAuthorisedButNotVisitedConsole(userInfo);
};

export const isFirstNavigationToConsole = (
  location: Location<any>,
  userInfo: UserInfoContextType | null
) => {
  return location.pathname === "/fp-console" && isAuthorisedButNotVisitedConsole(userInfo);
};
